const formatMoney = (centsRaw) => {
  const locale = window.shopLocale || 'en-US';
  const currency = window.shopCurrency || 'JPY';

  const isJapaneseLocale = locale.toLowerCase().startsWith('ja');
  const isJPY = currency === 'JPY';

  const formatOptions = {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: isJPY ? 0 : 2,
    maximumFractionDigits: isJPY ? 0 : 2,
    currencyDisplay: 'symbol',
  };

  const cents = Number(centsRaw);
  if (!Number.isFinite(cents) || cents <= 0) return '';

  const amount = isJPY ? Math.round(cents / 100) : cents / 100;
  if (amount <= 0) return '';

  return amount.toLocaleString(locale, formatOptions);
};

const toggleButtons = Array.from(
  document.querySelectorAll('.hdr__btn--search[data-action="toggle-search"]')
);
const desktopToggleBtn =
  document.getElementById('searchToggle') ||
  document.querySelector(
    '.site-header__icons .hdr__btn--search[data-action="toggle-search"]'
  );
const mobileToggleBtns = Array.from(
  document.querySelectorAll(
    '.site-header__mob-left .hdr__btn--search[data-action="toggle-search"]'
  )
);
const drawer = document.getElementById('SearchDrawer');
const headerFormEl = document.getElementById('HeaderSearchForm');
const mobileFormEl = document.getElementById('MobileHeaderSearchForm');
const mobileInputEl = document.getElementById('MobileSearchInput');
let resultsEl = null;

const headerRoot = document.querySelector('.site-header');
const headerTop = document.querySelector('.site-header__top');
const headerBottom = document.querySelector('.site-header__bottom');
const headerLogo = document.querySelector('.site-header__logo');
const headerLogoAnchor = document.querySelector('.site-header__logo a');
function measureHeaderHeight() {
  const bottoms = [];
  const candidates = [headerTop];
  candidates.forEach((el) => {
    if (!el) return;
    const rect = el.getBoundingClientRect();
    bottoms.push(rect.bottom);
  });
  const h = bottoms.length ? Math.max(...bottoms) : 0;
  return Math.max(0, Math.round(h));
}

function setPanelTop() {
  if (!drawer) return;
  const h = measureHeaderHeight();
  drawer.style.top = `${h}px`;
  document.documentElement.style.setProperty('--header-height', `${h}px`);
}

if (drawer) {
  resultsEl = drawer.querySelector('#SearchResults');
  const panelEl = drawer.querySelector('.search-drawer__inner');
  const closeBtn = drawer.querySelector('[data-action="close-search-drawer"]');
  const statusEl = drawer.querySelector('#SearchStatus');
  const headerInlineInput = headerFormEl
    ? headerFormEl.querySelector('#SearchInput')
    : null;
  const mobileInlineInput = mobileFormEl
    ? mobileFormEl.querySelector('#MobileSearchInput')
    : null;
  setPanelTop();
  window.addEventListener('load', setPanelTop);
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(setPanelTop);
    headerRoot && ro.observe(headerRoot);
    headerTop && ro.observe(headerTop);
    headerBottom && ro.observe(headerBottom);
    headerLogo && ro.observe(headerLogo);
    headerLogoAnchor && ro.observe(headerLogoAnchor);
  }
  let lastActiveInput = null;
  let savedScrollPosition = 0;

  const isMobile =
    window.__isMobile ||
    (() => window.matchMedia('(max-width: 1024px)').matches);

  function openDrawer() {
    setPanelTop();
    drawer.hidden = false;
    drawer.offsetHeight;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
    });
    document.documentElement.classList.add('search-drawer-open');
    if (isMobile()) {
      savedScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.top = `-${savedScrollPosition}px`;
    }
    if (window.__bringDrawerToFront) window.__bringDrawerToFront(drawer);
    const focusTarget =
      lastActiveInput || headerInlineInput || mobileInlineInput;
    focusTarget && focusTarget.focus();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('search-drawer-open');
    if (isMobile()) {
      document.body.style.top = '';
      window.scrollTo(0, savedScrollPosition);
    }
    if (resultsEl) resultsEl.innerHTML = '';
    drawer.addEventListener('transitionend', () => (drawer.hidden = true), {
      once: true,
    });
  }

  function setExpanded(target, expanded) {
    if (target === 'mobile') {
      mobileToggleBtns.forEach((b) =>
        b.setAttribute('aria-expanded', expanded ? 'true' : 'false')
      );
    } else if (target === 'desktop') {
      desktopToggleBtn?.setAttribute(
        'aria-expanded',
        expanded ? 'true' : 'false'
      );
    }
  }

  function openInlineForm(target) {
    if (target === 'mobile') {
      if (mobileFormEl) mobileFormEl.hidden = false;
    } else {
      if (headerFormEl) headerFormEl.hidden = false;
    }
    setExpanded(target, true);
    const inlineInput =
      target === 'mobile'
        ? mobileInputEl || document.getElementById('MobileSearchInput')
        : headerFormEl?.querySelector('#SearchInput');
    if (inlineInput) {
      lastActiveInput = inlineInput;
      setTimeout(() => {
        inlineInput.focus({ preventScroll: true });
        try {
          const len = inlineInput.value ? inlineInput.value.length : 0;
          inlineInput.setSelectionRange(len, len);
        } catch (e) {}
        if (inlineInput.value && inlineInput.value.trim()) {
          inlineInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }, 0);
    }
    document.documentElement.classList.add('search-open');
  }
  function closeInlineForm(target) {
    if (!target || target === 'mobile') {
      if (mobileFormEl) mobileFormEl.hidden = true;
    }
    if (!target || target === 'desktop') {
      if (headerFormEl) headerFormEl.hidden = true;
    }
    if (!target) {
      setExpanded('mobile', false);
      setExpanded('desktop', false);
    } else {
      setExpanded(target, false);
    }
    const anyOpen =
      (headerFormEl && !headerFormEl.hidden) ||
      (mobileFormEl && !mobileFormEl.hidden);
    if (!anyOpen) {
      document.documentElement.classList.remove('search-open');
    }
  }

  toggleButtons.forEach((btn) =>
    btn.addEventListener('click', (e) => {
      const isMobileBtn = !!btn.closest('.site-header__mob-left');
      const formToToggle = isMobileBtn ? mobileFormEl : headerFormEl;
      const willOpen = formToToggle ? formToToggle.hidden : true;

      if (willOpen) {
        openInlineForm(isMobileBtn ? 'mobile' : 'desktop');
      } else {
        closeInlineForm(isMobileBtn ? 'mobile' : 'desktop');
        if (!isMobileBtn) closeDrawer();
      }
    })
  );

  const stopEvents = (el) => {
    ['click', 'touchstart', 'pointerdown', 'mousedown'].forEach((type) => {
      el.addEventListener(type, (e) => e.stopPropagation());
    });
  };
  headerFormEl && stopEvents(headerFormEl);
  mobileFormEl && stopEvents(mobileFormEl);

  const desktopClearBtn = headerFormEl?.querySelector('.search-form__clear');
  const mobileClearBtn = mobileFormEl?.querySelector('.search-form__clear');

  const bindClearHandler = (btn, target, formEl, inputEl) => {
    if (!btn || !formEl) return;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      formEl.reset();
      if (resultsEl) resultsEl.innerHTML = '';
      closeDrawer();
      closeInlineForm(target);
      inputEl && inputEl.dispatchEvent(new Event('input', { bubbles: true }));
    });
  };

  bindClearHandler(
    desktopClearBtn,
    'desktop',
    headerFormEl,
    headerFormEl?.querySelector('#SearchInput')
  );
  bindClearHandler(
    mobileClearBtn,
    'mobile',
    mobileFormEl,
    mobileFormEl?.querySelector('#MobileSearchInput')
  );

  document.addEventListener('click', (e) => {
    const desktopOpen = headerFormEl && !headerFormEl.hidden;
    const mobileOpen = mobileFormEl && !mobileFormEl.hidden;
    const anyInlineOpen = desktopOpen || mobileOpen;
    const clickedInsideDesktop = e.target.closest('#HeaderSearchForm');
    const clickedInsideMobile = e.target.closest('#MobileHeaderSearchForm');
    const clickedToggleBtn = e.target.closest('.hdr__btn--search');
    const clickedInsideDrawer = e.target.closest('#SearchDrawer');

    if (
      anyInlineOpen &&
      !clickedInsideDesktop &&
      !clickedInsideMobile &&
      !clickedToggleBtn
    ) {
      closeInlineForm();
    }

    const drawerOpen = !drawer.hidden && drawer.classList.contains('is-open');
    if (
      drawerOpen &&
      !clickedInsideDrawer &&
      !clickedToggleBtn &&
      !clickedInsideDesktop &&
      !clickedInsideMobile
    ) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    const anyOpen =
      (headerFormEl && !headerFormEl.hidden) ||
      (mobileFormEl && !mobileFormEl.hidden);
    if (e.key === 'Escape' && anyOpen) closeInlineForm();
  });

  drawer.addEventListener('click', (e) => {
    const clickedOutsidePanel = panelEl
      ? !panelEl.contains(e.target)
      : e.target === drawer;
    if (clickedOutsidePanel) {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      closeDrawer();
    });
  }

  window.addEventListener('resize', setPanelTop);

  const debounce = (fn, ms = 250) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  };

  const bindPredictiveSearch = (inputEl) => {
    if (!inputEl || !resultsEl) return;
    const MAX_PRODUCTS_TO_EXPAND = 6;
    const MAX_TOTAL_ITEMS = 24;

    const getMarketPrefix = () => {
      try {
        const pathname = window.location.pathname;
        const match = pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/);
        return match ? `/${match[1]}` : '';
      } catch (e) {
        return '';
      }
    };

    const getHandleFromUrl = (url) => {
      try {
        const idx = url.indexOf('/products/');
        if (idx === -1) return null;
        const rest = url.slice(idx + '/products/'.length);
        const handle = rest.split('?')[0].split('#')[0].replace(/^\//, '');
        return handle || null;
      } catch (e) {
        return null;
      }
    };

    const fetchProductJson = async (handle) => {
      try {
        const marketPrefix = getMarketPrefix();
        const res = await fetch(`${marketPrefix}/products/${handle}.js`);
        if (!res.ok) return null;
        const data = await res.json();
        return data;
      } catch (e) {
        return null;
      }
    };

    const findColorOptionIndex = (options) => {
      if (!Array.isArray(options)) return -1;
      for (let i = 0; i < options.length; i += 1) {
        const opt = options[i];
        let name = '';
        if (typeof opt === 'string') {
          name = opt.toLowerCase();
        } else if (opt && typeof opt === 'object') {
          name = String(opt.name || opt.title || '').toLowerCase();
        } else {
          name = String(opt || '').toLowerCase();
        }
        if (
          name === 'color' ||
          name === 'colour' ||
          name.includes('color') ||
          name === '色' ||
          name.includes('色')
        ) {
          return i;
        }
      }
      return -1;
    };

    const uniqueBy = (arr, keyFn) => {
      const seen = new Set();
      const out = [];
      for (const item of arr) {
        const key = keyFn(item);
        if (key == null || seen.has(key)) continue;
        seen.add(key);
        out.push(item);
      }
      return out;
    };

    const buildItemsFromProductJson = (baseProduct, productJson) => {
      if (!productJson) return [];

      const items = [];
      const colorIdx = findColorOptionIndex(productJson.options);

      if (colorIdx === -1) {
        items.push({
          url: baseProduct.url,
          title: productJson.title || baseProduct.title,
          priceCents:
            productJson.price ?? Math.round(baseProduct.price_min || 0),
          image:
            baseProduct.featured_image?.url || productJson.images?.[0] || null,
        });
        return items;
      }

      const byColor = new Map();
      for (const v of productJson.variants || []) {
        let colorVal = null;
        if (colorIdx === 0) {
          colorVal = v?.option1;
        } else if (colorIdx === 1) {
          colorVal = v?.option2;
        } else if (colorIdx === 2) {
          colorVal = v?.option3;
        }

        if (!colorVal && Array.isArray(v?.options)) {
          colorVal = v.options[colorIdx];
        }

        if (!colorVal) continue;
        const existed = byColor.get(colorVal);
        if (!existed || (!existed.available && v.available)) {
          byColor.set(colorVal, v);
        }
      }

      if (byColor.size === 0) {
        items.push({
          url: baseProduct.url,
          title: productJson.title || baseProduct.title,
          priceCents:
            productJson.price ?? Math.round(baseProduct.price_min || 0),
          image:
            baseProduct.featured_image?.url || productJson.images?.[0] || null,
        });
        return items;
      }

      const cleanBaseUrl = (() => {
        const urlStr = baseProduct.url || '';
        const queryIdx = urlStr.indexOf('?');
        if (queryIdx === -1) return urlStr;

        const basePath = urlStr.substring(0, queryIdx);
        const queryStr = urlStr.substring(queryIdx + 1);
        const params = new URLSearchParams(queryStr);
        params.delete(`option${colorIdx + 1}`);

        const remainingParams = params.toString();
        return remainingParams ? `${basePath}?${remainingParams}` : basePath;
      })();

      for (const [colorVal, v] of byColor) {
        const qp = encodeURIComponent(colorVal);
        const separator = cleanBaseUrl.includes('?') ? '&' : '?';
        const link = `${cleanBaseUrl}${separator}option${colorIdx + 1}=${qp}`;
        const image =
          v?.featured_image?.src ||
          v?.image ||
          baseProduct.featured_image?.url ||
          productJson.images?.[0] ||
          null;

        items.push({
          url: link,
          title: productJson.title || baseProduct.title,
          priceCents:
            v?.price ??
            productJson.price ??
            Math.round(baseProduct.price_min || 0),
          image,
          color: colorVal,
          available: !!v?.available,
        });
      }

      return uniqueBy(
        items,
        (it) => `${it.title}::${it.color || ''}::${it.url}`
      );
    };

    function renderItems(items) {
      if (!Array.isArray(items) || items.length === 0) {
        return '<li class="search-empty">該当なし</li>';
      }
      const limited = items.slice(0, MAX_TOTAL_ITEMS);
      return limited
        .map((it) => {
          const safeAlt = (it.title || '').replace(/"/g, '&quot;');
          const priceHtml =
            typeof it.priceCents === 'number'
              ? `<span class="search-item__price">${formatMoney(
                  it.priceCents
                )}</span>`
              : '';
          const imgHtml = it.image
            ? `<img src="${it.image}${
                it.image.includes('?') ? '&' : '?'
              }width=100" alt="${safeAlt}">`
            : '';
          return `
            <li role="option">
              <a href="${it.url}" class="search-item">
                ${imgHtml}
                <div class="search-item__info">
                  <span class="search-item__ttl">${safeAlt}</span>
                  ${
                    it.color
                      ? `<span class="search-item__meta">${it.color}</span>`
                      : ''
                  }
                  ${priceHtml}
                </div>
              </a>
            </li>`;
        })
        .join('');
    }

    const marketPrefix = getMarketPrefix();
    const isUnsupportedLocale =
      marketPrefix === '/ja' || marketPrefix === '/ja-jp';

    if (isUnsupportedLocale) {
      inputEl.addEventListener(
        'input',
        debounce(async () => {
          lastActiveInput = inputEl;
          const query = inputEl.value.trim();

          if (!query) {
            resultsEl.innerHTML = '';
            if (statusEl) statusEl.textContent = '';
            closeDrawer();
            return;
          }

          const searchingText =
            window.SearchTranslations?.searching || '検索中...';
          resultsEl.innerHTML = `<li class="search-loading">${searchingText}</li>`;
          if (statusEl) statusEl.textContent = searchingText;
          panelEl && panelEl.classList.add('status-only');
          if (drawer.hidden) openDrawer();

          try {
            const productsUrl = `${marketPrefix}/collections/all/products.json?limit=250`;
            const response = await fetch(productsUrl);

            if (!response.ok) {
              throw new Error(`Failed to fetch products: ${response.status}`);
            }

            const data = await response.json();
            const allProducts = data?.products || [];

            const queryLower = query.toLowerCase();
            const matchedProducts = allProducts
              .filter((product) => {
                const title = String(product.title || '').toLowerCase();
                const tagsStr = Array.isArray(product.tags)
                  ? product.tags.join(' ').toLowerCase()
                  : String(product.tags || '').toLowerCase();
                const body = String(product.body_html || '').toLowerCase();
                const vendor = String(product.vendor || '').toLowerCase();
                return (
                  title.includes(queryLower) ||
                  tagsStr.includes(queryLower) ||
                  body.includes(queryLower) ||
                  vendor.includes(queryLower)
                );
              })
              .slice(0, MAX_TOTAL_ITEMS);

            if (matchedProducts.length === 0) {
              const noResultsText =
                window.SearchTranslations?.noResults || '該当なし';
              resultsEl.innerHTML = `<li class="search-empty">${noResultsText}</li>`;
              if (statusEl) statusEl.textContent = noResultsText;
              panelEl && panelEl.classList.add('status-only');
              return;
            }

            const limited = matchedProducts.slice(0, MAX_PRODUCTS_TO_EXPAND);
            const productJsons = await Promise.all(
              limited.map((p) => {
                const handle = p.handle || getHandleFromUrl(p.url || '');
                return handle
                  ? fetchProductJson(handle)
                  : Promise.resolve(null);
              })
            );

            const expandedItems = [];
            for (let i = 0; i < limited.length; i += 1) {
              const base = limited[i];
              const pj = productJsons[i];

              let productUrl = base.url || '';
              if (productUrl.startsWith('/products/')) {
                productUrl = `${marketPrefix}${productUrl}`;
              } else if (productUrl.startsWith('products/')) {
                productUrl = `${marketPrefix}/${productUrl}`;
              } else if (!productUrl.startsWith('/') && productUrl) {
                productUrl = `${marketPrefix}/products/${productUrl}`;
              } else if (!productUrl && base.handle) {
                productUrl = `${marketPrefix}/products/${base.handle}`;
              }

              let featuredImage = null;
              if (base.featured_image) {
                if (typeof base.featured_image === 'string') {
                  featuredImage = { url: base.featured_image };
                } else {
                  featuredImage = base.featured_image;
                }
              }

              const baseProduct = {
                url: productUrl,
                title: base.title || '',
                featured_image: featuredImage,
                price_min: base.variants?.[0]?.price || 0,
              };

              const items = buildItemsFromProductJson(baseProduct, pj);
              expandedItems.push(...items);
              if (expandedItems.length >= MAX_TOTAL_ITEMS) break;
            }

            if (!Array.isArray(expandedItems) || expandedItems.length === 0) {
              resultsEl.innerHTML = '<li class="search-empty">該当なし</li>';
              if (statusEl) statusEl.textContent = '該当なし';
              panelEl && panelEl.classList.add('status-only');
              return;
            }

            resultsEl.innerHTML = renderItems(expandedItems);
            if (statusEl)
              statusEl.textContent =
                window.SearchTranslations?.results || '検索結果';
            panelEl && panelEl.classList.remove('status-only');
            if (drawer.hidden) openDrawer();
          } catch (e) {
            console.error('[Search Drawer] Search error:', e);
            const searchUrl = `${marketPrefix}/search?q=${encodeURIComponent(
              query
            )}`;
            resultsEl.innerHTML = `
              <li class="search-empty">
                <a href="${searchUrl}" style="text-decoration: underline; display: block; padding: 1rem;">
                  「${query}」の検索結果を見る →
                </a>
              </li>`;
            if (statusEl) statusEl.textContent = '検索';
            panelEl && panelEl.classList.add('status-only');
            if (drawer.hidden) openDrawer();
          }
        }, 300)
      );
      return;
    }

    inputEl.addEventListener(
      'input',
      debounce(async () => {
        lastActiveInput = inputEl;
        const query = inputEl.value.trim();
        if (!query) {
          resultsEl.innerHTML = '';
          if (statusEl) statusEl.textContent = '';
          closeDrawer();
          return;
        }

        const searchingText =
          window.SearchTranslations?.searching || '検索中...';
        resultsEl.innerHTML = `<li class="search-loading">${searchingText}</li>`;
        if (statusEl) statusEl.textContent = searchingText;
        panelEl && panelEl.classList.add('status-only');
        if (drawer.hidden) openDrawer();

        try {
          let baseUrl =
            window.routes?.predictiveSearch || '/search/suggest.json';

          if (!baseUrl.endsWith('.json')) {
            baseUrl = baseUrl.endsWith('/suggest')
              ? `${baseUrl}.json`
              : `${baseUrl}/suggest.json`;
          }

          const separator = baseUrl.includes('?') ? '&' : '?';
          const url =
            `${baseUrl}${separator}q=${encodeURIComponent(query)}` +
            `&resources[type]=product&resources[limit]=10`;

          let response;
          try {
            response = await fetch(url);
          } catch (fetchError) {
            console.error('Fetch error:', fetchError);
            const marketPrefix = getMarketPrefix();
            const basePath = marketPrefix || '';
            const searchUrl = `${basePath}/?query=${encodeURIComponent(query)}`;
            resultsEl.innerHTML = `
              <li class="search-empty">
                <a href="${searchUrl}" style="text-decoration: underline;">
                  「${query}」の検索結果を見る
                </a>
              </li>`;
            if (statusEl)
              statusEl.textContent =
                window.SearchTranslations?.searchNotSupported ||
                'この言語では予測検索が利用できません';
            panelEl && panelEl.classList.add('status-only');
            if (drawer.hidden) openDrawer();
            return;
          }

          if (!response.ok) {
            const status = response.status;
            const marketPrefix = getMarketPrefix();

            if (status === 417 || status === 422) {
              const basePath = marketPrefix || '';
              const searchUrl = `${basePath}/search?q=${encodeURIComponent(
                query
              )}`;

              const notSupportedText =
                window.SearchTranslations?.searchNotSupported ||
                'この言語では予測検索が利用できません';
              resultsEl.innerHTML = `
                <li class="search-empty">
                  <a href="${searchUrl}" style="text-decoration: underline;">
                    「${query}」の検索結果を見る
                  </a>
                </li>`;
              if (statusEl) statusEl.textContent = notSupportedText;
              panelEl && panelEl.classList.add('status-only');
              if (drawer.hidden) openDrawer();
              return;
            }

            console.error('Search API error:', {
              status: status,
              statusText: response.statusText,
              url: url,
            });
            throw new Error(
              `Search API returned ${status}: ${response.statusText}`
            );
          }

          let data;
          try {
            data = await response.json();
          } catch (jsonError) {
            console.error('Failed to parse JSON response:', jsonError);
            throw new Error('Invalid JSON response from search API');
          }

          const products = data?.resources?.results?.products || [];

          if (products.length === 0) {
            const noResultsText =
              window.SearchTranslations?.noResults || '該当なし';
            resultsEl.innerHTML = `<li class="search-empty">${noResultsText}</li>`;
            if (statusEl) statusEl.textContent = noResultsText;
            panelEl && panelEl.classList.add('status-only');
            if (drawer.hidden) openDrawer();
            return;
          }

          const limited = products.slice(0, MAX_PRODUCTS_TO_EXPAND);
          const productJsons = await Promise.all(
            limited.map((p) => {
              const handle = getHandleFromUrl(p.url || '');
              return handle ? fetchProductJson(handle) : Promise.resolve(null);
            })
          );

          const expandedItems = [];
          const marketPrefix = getMarketPrefix();
          for (let i = 0; i < limited.length; i += 1) {
            const base = limited[i];
            const pj = productJsons[i];

            let productUrl = base.url || '';
            if (productUrl && !productUrl.startsWith('http')) {
              if (productUrl.startsWith('/products/')) {
                productUrl = `${marketPrefix}${productUrl}`;
              } else if (productUrl.startsWith('products/')) {
                productUrl = `${marketPrefix}/${productUrl}`;
              } else if (!productUrl.startsWith('/')) {
                productUrl = `${marketPrefix}/products/${productUrl}`;
              }
            }

            let featuredImage = null;
            if (base.featured_image) {
              if (typeof base.featured_image === 'string') {
                featuredImage = { url: base.featured_image };
              } else {
                featuredImage = base.featured_image;
              }
            }

            const baseProduct = {
              url: productUrl,
              title: base.title || '',
              featured_image: featuredImage,
              price_min: base.price_min || 0,
            };

            const items = buildItemsFromProductJson(baseProduct, pj);
            expandedItems.push(...items);
            if (expandedItems.length >= MAX_TOTAL_ITEMS) break;
          }

          resultsEl.innerHTML = renderItems(expandedItems);
          if (statusEl)
            statusEl.textContent =
              window.SearchTranslations?.results || '検索結果';
          panelEl && panelEl.classList.remove('status-only');

          if (drawer.hidden) openDrawer();
        } catch (e) {
          console.error('Search error:', e);
          const errorText =
            window.SearchTranslations?.searchError ||
            '申し訳ありません。検索中にエラーが発生しました。';
          const errorStatusText =
            window.SearchTranslations?.errorOccurred || 'エラーが発生しました';
          resultsEl.innerHTML = `
            <li class="search-error">
              ${errorText}
            </li>`;
          if (statusEl) statusEl.textContent = errorStatusText;
          panelEl && panelEl.classList.add('status-only');
          if (drawer.hidden) openDrawer();
        }
      }, 300)
    );
  };

  console.log(
    '[Search Drawer] Binding predictive search, header input:',
    headerInlineInput,
    'mobile input:',
    mobileInlineInput
  );
  bindPredictiveSearch(headerInlineInput);
  bindPredictiveSearch(mobileInlineInput);

  if (headerFormEl && headerInlineInput) {
    headerFormEl.addEventListener('submit', (e) => {
      e.preventDefault();
      openDrawer();
      headerInlineInput.dispatchEvent(new Event('input', { bubbles: true }));
    });

    headerFormEl.addEventListener('reset', () => {
      if (resultsEl) resultsEl.innerHTML = '';
      closeDrawer();
    });
  }

  if (mobileFormEl && mobileInlineInput) {
    mobileFormEl.addEventListener('submit', (e) => {
      e.preventDefault();
      openDrawer();
      mobileInlineInput.dispatchEvent(new Event('input', { bubbles: true }));
    });

    mobileFormEl.addEventListener('reset', () => {
      if (resultsEl) resultsEl.innerHTML = '';
      closeDrawer();
    });
  }
}
